import { ColumnOptions, DataType, FormattingRule } from "@/types/insights"
import { FirstDayOfWeekSetting } from "./tenantSetting"
import store from "../store/index"
import { CaseColumn } from "./caseColumns"
import { AuditUser } from "./auditUser"
import { inlineEditMode } from "./insights/selectiveInlineEdit"

export interface View {
	id?: string
	tenantId: string
	title: string
	folder: string
	teams: any[]
	created?: Date
	createdBy?: AuditUser
	lastUpdated?: Date
	lastUpdatedBy?: AuditUser
	viewTeams: any[]
	clauses: Clause[]
	sortBy: string
	groupBy?: string | null
	groupByOption?: string | null
	sortByLabel?: string
	groupByLabel?: string | null
	columns: string[]
	groupByDataType: DataType | null
	formattingRules?: { [key: string]: FormattingRule[] }
	columnOptions?: { [key: string]: ColumnOptions }
	timeZone?: string
	inlineEditMode?: inlineEditMode
}

export interface Clause {
	key?: string | null
	id?: string
	field?: string
	label: string
	operator?: number | null
	dataSourceId?: string

	fieldData?: CaseColumn
	fieldDataType: number

	dynamicField: boolean
	dynamicValue: boolean
	dynamicParameter?: string | null

	value?: string | null
	valueLabel?: string
	definitionId?: string
	definitionField?: string
	definitionFieldLabel?: string
	definitionFieldDataType?: number
	itemLabel?: string

	orClause?: boolean
	subClauses?: Clause[]
	isValid?: boolean
	parentClauseId?: string | null
	valueObject?: any

	searchClauseParameters?: SearchClauseParameters

	userField?: string | null
	userFieldData?: CaseColumn | null
	userFieldDataType?: number | null

	invalidErrorInfo?: string | null // Used only in the UI to show info about invalid calculation filters
}

export interface SearchClauseParameters {
	startDayOfWeek: DayOfWeek,
	weekNumber?: number,
	startDate?: Date,
	endDate?: Date,
	timeSpentClause: TimeSpentClause
	startMonthRange?: Date,
    endMonthRange?: Date
}

export interface TimeSpentClause {
	searchValue: string,
	searchLabel: string,
	hoursSpent: number,
	trackingFieldId: string
}

export enum DayOfWeek {
	Sunday = 0,
	Monday = 1,
	Tuesday = 2,
	Wednesday = 3,
	Thursday = 4,
	Friday = 5,
	Saturday = 6
}

const defaultSearchClauseParameters = {
	startDayOfWeek: DayOfWeek.Monday,
	timeSpentClause: {
		searchValue: "",
		searchLabel: "",
		hoursSpent: 0,
		trackingFieldId: ""
	}
}

function getDefaultTimeSpentClause () {
	return {
		searchValue: "",
		searchLabel: "",
		hoursSpent: 0,
		trackingFieldId: ""
	}
}

function getDefaultFirstDayOfWeek (): DayOfWeek {
	const tenantSettings = store.getters.getTenantSettings as { [key: string]: any }

	if (tenantSettings && tenantSettings["defaultFirstDayOfWeek"]) {
		const firstDayOfWeekSettings = tenantSettings["defaultFirstDayOfWeek"] as FirstDayOfWeekSetting
		if (!firstDayOfWeekSettings.enabled) {
			return DayOfWeek.Monday
		} else {
			return firstDayOfWeekSettings.dayOfWeekSelected
		}
	} else {
		return DayOfWeek.Monday
	}
}

function getDefaultSearchClauseParameters () {
	return {
		startDayOfWeek: getDefaultFirstDayOfWeek(),
		timeSpentClause: getDefaultTimeSpentClause()
	}
}

export { getDefaultTimeSpentClause, getDefaultSearchClauseParameters, defaultSearchClauseParameters }
